import Connection from './Cisco/Connection'
import Modal from './Cisco/Modal'
import SubscriptionForm from "./Cisco/SubscriptionForm";
import Room from "./Cisco/Room";
import Widget from "./Cisco/Widget";

export default class Cisco {

    constructor() {
        this.setupAssets();
        this.subscribeUser = this.__subscribeUser.bind(this);
        this.connection = new Connection();
        this.modal = new Modal( this );
        this.form = new SubscriptionForm( this );
        this.form.addAction( this.subscribeUser );
    }

    buttonListeners() {
        this.modal.buttonListeners();
    }

    getModal() {
        return this.modal.getModal();
    }

    getForm() {
        return this.form;
    }

    getConnection() {
        return this.connection;
    }

    __subscribeUser( ev ) {
        this.form.hide();
        this.modal.startLoading();
        this.form.send()
            .then( async guest => {
                document.querySelector('.event-sticker').style.display = 'none';
                this.guest = guest;

                let guestToken = await guest.authenticate( this.connection );
                this.room = new Room( this );
                await this.room.create( guest.guest, this.form.get('agent') )
                await this.room.addMembers( guestToken.body.token, this.form.get('agent') );
                let room = this.room.room

                setTimeout( () => {
                    this.modal.stopLoading();
                    Widget.connect( room.id, guest.token() )
                    this.modal.setFloatingButton();
                }, 2500 );
            })
            .catch( response => {
                console.log(response);
                this.modal.stopLoading();
                this.form.show()
            })
    }

    destroy() {
        this.buttons.forEach(el => el.removeEventListener('click', this._handler))
        this.room = null;
        this.buttons = null;
    }

    setupAssets() {
        // <script src="https://code.s4d.io/widget-space/production/bundle.js"></script>
        let script = document.createElement('script');
        script.src = 'https://code.s4d.io/widget-space/production/bundle.js';
        document.body.appendChild( script );

        //<link rel="stylesheet" href="https://code.s4d.io/widget-space/production/main.css">
        let style = document.createElement('link')
        style.rel = 'stylesheet';
        style.href = 'https://code.s4d.io/widget-space/production/main.css';
        document.head.appendChild( style );
    }
}